<h1 class="_primary cell shrink"[i18nKey]="'evaluations.title'"></h1>

<kiwi-spacer [size]="32"></kiwi-spacer>

<div class="cell auto grid-x grid-margin-x">
    <kiwi-evaluations-menu class="cell shrink blockContent"></kiwi-evaluations-menu>

    <div class="cell auto grid-y">
        <router-outlet></router-outlet>
    </div>
</div>
